module.exports = __webpack_public_path__ + "introduce-02.png?1a02ebbc2a08a93263efcd013d681a0d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/introduce-02.png
// module id = 136
// module chunks = 0